import type { RequirementsProps } from "./Requirements";
import { UniformFields } from "./UniformFields";

export function RequirementsFlagged(props: Readonly<RequirementsProps>) {
  return <UniformFields form={props.form} />;
}
